var _path, _path2, _path3, _rect, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTim4Logo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 58,
    viewBox: "0 0 132 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.344 11.4V17.736H16.272V45H9.648V17.736H0.624V11.4H25.344Z",
    fill: "#2E375B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83 11.4V45H76.424V23.208L66.968 38.808H66.2L56.744 23.256V45H50.12V11.4H56.936L66.584 27.288L76.184 11.4H83Z",
    fill: "#2E375B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.271 17.1H39.1V14H33.9V17.1H31.729C30.78 17.1 30 18.03 30 19.1615V42.923C30 44.07 30.78 45 31.729 45H41.258C42.22 45 43 44.07 43 42.9385V19.1615C43 18.03 42.22 17.1 41.271 17.1ZM35.2 41.9V33.375H32.6L37.8 21.75V30.275H40.4L35.2 41.9Z",
    fill: "#E56A43"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 25.4,
    width: 8,
    height: 6.2,
    fill: "#2E375B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.6 11.4V45H118V38.6H98V32.9L115 11.4H124.6ZM118 18.1V32.6H106.5L118 18.1Z",
    fill: "#2E375B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTim4Logo);
export default __webpack_public_path__ + "static/media/TIM4Logo.97d374d516e084c87f65f51888d9154e.svg";
export { ForwardRef as ReactComponent };